import type { modulesConfigElem } from "../store/slices/app.slice";

const pickStr = (...vals: unknown[]): string => {
	for (const v of vals) {
		if (typeof v === "string" && v.trim()) return v.trim();
	}
	return "";
};

export const readStoredModulesConfig = (): modulesConfigElem[] | null => {
	if (typeof window === "undefined") return null;
	try {
		const raw = localStorage.getItem("modulesConfig");
		if (!raw) return null;
		const parsed = JSON.parse(raw) as unknown;
		if (!Array.isArray(parsed) || parsed.length === 0) return null;

		const normalized = parsed
			.map((item, index): modulesConfigElem | null => {
				if (!item || typeof item !== "object") return null;
				const o = item as Record<string, unknown>;
				const moduleName = pickStr(o.moduleName, o.module_name);
				const moduleCategory = pickStr(o.moduleCategory, o.module_category);
				if (!moduleName || !moduleCategory) return null;

				const rawW = o.moduleWeight ?? o.module_weight;
				const rawO = o.moduleOrder ?? o.module_order;
				const w =
					rawW === undefined || rawW === null || rawW === "" ?
						Number.NaN
					:	Number(rawW);
				const ord =
					rawO === undefined || rawO === null || rawO === "" ?
						Number.NaN
					:	Number(rawO);
				if (!Number.isFinite(w)) return null;
				const moduleOrder = Number.isFinite(ord) ? ord : index + 1;

				return {
					moduleName,
					moduleCategory,
					moduleWeight: w,
					moduleOrder,
				};
			})
			.filter((x): x is modulesConfigElem => x !== null);

		return normalized.length > 0 ? normalized : null;
	} catch {
		return null;
	}
};
